<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="CN" id="_idParaDest-3"> </p>
<p class="Title">Father of</p>
<p class="Title">the Rain</p>
<p class="Sub">A Novel</p>
<p class="Title">Lily King</p>
<p class="BT1stPara ParaOverride-2"><span class="CharOverride-5"><img alt="" class="_idGenObjectAttribute-1" src="image/V-1.jpg"/></span></p>
<p class="BT1stPara ParaOverride-1">Grove Press</p>
<p class="BT1stPara ParaOverride-1"><span class="CharOverride-3">New York</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 97808021970852.vue?b0daad4c